import { AnchorHTMLAttributes, HTMLAttributeAnchorTarget } from 'react';

import { Link as DefaultLink } from 'react-router-dom';

import { addQueryParamToUrl } from '../../helpers';
import { TRoutePaths, TRoutePathsWithParams, TRouteQuery } from '../../models';

interface ILinkProps<T extends TRoutePaths>
  extends Omit<
    AnchorHTMLAttributes<HTMLAnchorElement>,
    'dangerouslySetInnerHTML'
  > {
  to: TRoutePathsWithParams<T>;
  params?: TRouteQuery<T>;
  target?: HTMLAttributeAnchorTarget;
}

function Link<T extends TRoutePaths = TRoutePaths>({
  to,
  params,
  ...rest
}: ILinkProps<T>) {
  const path = params ? addQueryParamToUrl(to, params) : to;

  return <DefaultLink to={path} {...rest} />;
}

export default Link;
